import { Component, Input } from '@angular/core';
import { SelectEvent as LayoutSelectEvent } from '@progress/kendo-angular-layout';
import { PageSize } from 'src/app/core/models/base';
import { DeviceStore } from 'src/app/stores/component/device-store';


@Component({
    selector: 'app-revisions-detail-devices',
    templateUrl: './revisions-detail-devices.component.html',
    styleUrl: './revisions-detail-devices.component.scss',
    standalone: false
})
export class RevisionsDetailDevicesComponent {

  ////////////////
  // variables //
  //////////////

  @Input() revisionId;
  @Input() revisionStatus;
  @Input() companyId;
  @Input() tenantOnRevision;

  constructor(
  ) {}

  ngOnInit() {
  }
  
  
  // tab element
  public onTabSelect(e: LayoutSelectEvent): void {
  }
}